import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTemperature = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("g", {
		id: "Group_2423",
		"data-name": "Group 2423",
		transform: "translate(-184.087 -336.262)",
		children: /* @__PURE__ */ _jsxs("g", {
			id: "Group_2422",
			"data-name": "Group 2422",
			transform: "translate(185.361 339.92)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					id: "Path_2248",
					"data-name": "Path 2248",
					d: "M195.264,350.832c0-2.268-1.12-4.645-3.261-4.8a3.524,3.524,0,0,0-2.716.97,6.623,6.623,0,0,0-1.8,4.813,15.379,15.379,0,0,0,.925,4.077c.172.535.319,1,.386,1.295.05.224.1.5.147.8.281,1.671.793,4.717,3.167,4.717a3,3,0,0,0,.351-.021,2.593,2.593,0,0,0,1.843-.974c.913-1.193.629-3.1.378-4.784a13.817,13.817,0,0,1-.2-1.821,5.45,5.45,0,0,1,.311-1.577A8.776,8.776,0,0,0,195.264,350.832ZM193.2,357.15c.2,1.32.441,2.964-.086,3.652a1.1,1.1,0,0,1-.827.4c-1.059.124-1.481-1.174-1.865-3.456-.057-.335-.108-.639-.163-.884-.081-.364-.238-.855-.421-1.425a14.828,14.828,0,0,1-.854-3.619,5.2,5.2,0,0,1,1.321-3.715,2.038,2.038,0,0,1,1.423-.578c.054,0,.108,0,.163.006,1.171.085,1.87,1.747,1.87,3.3a7.413,7.413,0,0,1-.4,2.271,6.774,6.774,0,0,0-.374,2.006A14.7,14.7,0,0,0,193.2,357.15Z",
					transform: "translate(-187.488 -346.022)",
					fill: "current"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Path_2249",
					"data-name": "Path 2249",
					d: "M229.954,347a3.52,3.52,0,0,0-2.716-.97c-2.141.155-3.261,2.532-3.261,4.8a8.776,8.776,0,0,0,.465,2.7,5.45,5.45,0,0,1,.311,1.577,13.754,13.754,0,0,1-.2,1.821c-.251,1.683-.535,3.591.378,4.784a2.594,2.594,0,0,0,1.843.974,2.921,2.921,0,0,0,.351.021c2.373,0,2.886-3.045,3.167-4.716.051-.306.1-.582.147-.807.067-.3.215-.76.386-1.295a15.379,15.379,0,0,0,.925-4.077A6.623,6.623,0,0,0,229.954,347Zm-.554,8.432c-.183.57-.34,1.061-.421,1.424-.055.246-.107.55-.163.886-.384,2.281-.8,3.579-1.865,3.455a1.1,1.1,0,0,1-.827-.4c-.527-.688-.282-2.331-.086-3.651a14.7,14.7,0,0,0,.214-2.042,6.774,6.774,0,0,0-.374-2.006,7.413,7.413,0,0,1-.4-2.271c0-1.558.7-3.22,1.87-3.3.055,0,.109-.006.163-.006a2.038,2.038,0,0,1,1.423.578,5.2,5.2,0,0,1,1.321,3.715A14.828,14.828,0,0,1,229.4,355.433Z",
					transform: "translate(-210.302 -346.022)",
					fill: "current"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Path_2250",
					"data-name": "Path 2250",
					d: "M215.451,371.326a1.22,1.22,0,1,0-2.439,0v4.866a1.586,1.586,0,0,0,.906,2.57,1.628,1.628,0,0,0,.312.03,1.586,1.586,0,0,0,1.222-2.6Zm-.688,6.526a.837.837,0,0,1-1.115-1.246.377.377,0,0,0,.113-.268v-5.012a.47.47,0,1,1,.94,0v5.012a.376.376,0,0,0,.114.269.835.835,0,0,1-.052,1.245Z",
					transform: "translate(-203.217 -361.08)",
					fill: "current"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Path_2251",
					"data-name": "Path 2251",
					d: "M216.2,381.545v-3.425a.187.187,0,0,0-.375,0v3.425a.517.517,0,1,0,.375,0Zm-.187.713a.233.233,0,0,1-.233-.233.225.225,0,0,1,.047-.133c-.262.114.09.451.186.422.443-.135.279-.365.185-.422a.225.225,0,0,1,.047.133A.233.233,0,0,1,216.015,382.258Z",
					transform: "translate(-205.001 -365.973)",
					fill: "current"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Path_2252",
					"data-name": "Path 2252",
					d: "M210.882,372.266h-.562a.187.187,0,1,0,0,.375h.562a.187.187,0,1,0,0-.375Z",
					transform: "translate(-201.646 -362.43)",
					fill: "current"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Path_2253",
					"data-name": "Path 2253",
					d: "M211.35,374.145h-.281a.187.187,0,1,0,0,.375h.281a.187.187,0,0,0,0-.375Z",
					transform: "translate(-202.115 -363.605)",
					fill: "current"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Path_2254",
					"data-name": "Path 2254",
					d: "M210.882,376.023h-.562a.187.187,0,0,0,0,.375h.562a.187.187,0,1,0,0-.375Z",
					transform: "translate(-201.646 -364.779)",
					fill: "current"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Path_2255",
					"data-name": "Path 2255",
					d: "M211.35,377.9h-.281a.187.187,0,1,0,0,.375h.281a.187.187,0,0,0,0-.375Z",
					transform: "translate(-202.115 -365.954)",
					fill: "current"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Path_2256",
					"data-name": "Path 2256",
					d: "M210.882,379.78h-.562a.187.187,0,1,0,0,.375h.562a.187.187,0,1,0,0-.375Z",
					transform: "translate(-201.646 -367.128)",
					fill: "current"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Path_2257",
					"data-name": "Path 2257",
					d: "M211.35,381.658h-.281a.187.187,0,1,0,0,.375h.281a.187.187,0,0,0,0-.375Z",
					transform: "translate(-202.115 -368.303)",
					fill: "current"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Path_2258",
					"data-name": "Path 2258",
					d: "M210.882,383.537h-.562a.187.187,0,1,0,0,.375h.562a.187.187,0,1,0,0-.375Z",
					transform: "translate(-201.646 -369.477)",
					fill: "current"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Path_2259",
					"data-name": "Path 2259",
					d: "M211.35,385.415h-.281a.187.187,0,1,0,0,.375h.281a.187.187,0,0,0,0-.375Z",
					transform: "translate(-202.115 -370.652)",
					fill: "current"
				})
			]
		})
	})]
});
const ForwardRef = forwardRef(SvgTemperature);
export { ForwardRef as ReactComponent };
